// src/utils/snack.ts
import { SNACKSTATUS } from '@/stores/util';

export const useSnack = (
  emit: (event: 'snack', objType: string, snackType: SNACKSTATUS, err?: string) => void,
) => {
  const throwSnack = (objType: string, snackType: SNACKSTATUS, err: string = '') => {
    emit('snack', objType, snackType, err);
  };

  return { throwSnack };
};

export const basicColors: { label: string; value: string }[] = [
  { label: 'Red', value: 'Red' },
  { label: 'Green', value: 'Green' },
  { label: 'Blue', value: 'Blue' },
  { label: 'Yellow', value: 'Yellow' },
  { label: 'Black', value: 'Black' },
  { label: 'White', value: 'White' },
  { label: 'Gray', value: 'Gray' },
  { label: 'Orange', value: 'Orange' },
  { label: 'Purple', value: 'Purple' },
  { label: 'Pink', value: 'Pink' },
];

export const downloadFile = (url?: string) => {
  if (!url) return;
  // Create a temporary link element
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', '');
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
